import { Button, ButtonVariants } from '@components/button/Button';
import { ModalContainer } from '@components/modal/ModalContainer';
import { DateAndGuestCountFilterPopover } from './DateAndGuestCountFilterPopover';
import styles from './MobileFiltersModal.scss';
import './Datetime.overrides.css';

interface MobileFiltersModalProps {
  onClose: () => void;
}

export const MobileFiltersModal = ({ onClose }: MobileFiltersModalProps) => (
  <ModalContainer className="mobile-filters-modal" isOpen onClose={onClose}>
    <div
      aria-label="Filter Availabilities"
      className={styles.container}
      role="dialog"
    >
      <DateAndGuestCountFilterPopover
        calendarClassName={styles.calendar}
        maxGuestCountMessageClassName={styles.maxGuestCountMessage}
      />
      <Button
        className={styles.button}
        label="Close"
        onClick={onClose}
        variant={ButtonVariants.Primary}
      />
    </div>
  </ModalContainer>
);
